module.exports = __webpack_public_path__ + "static/ApplicantTrackingSystem-6459805453e34981671c6ef1c37f026e.png";